import { colors } from '../../../packages';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    paddingTop: 88,
    gap: 40,
  },
  rootWithAlerts: {
    gap: '20px',
  },
  alertWrapper: {
    display: 'flex',
    padding: '16px',
    gap: '8px',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: '8px',
    background: colors.destructive50,
    border: `2px solid ${colors.destructive300}`,
  },
  infoIcon: {
    color: colors.warning500,
  },
  documentIcon: {
    color: colors.indigo500,
  },
  discrepancyIcon: {
    color: colors.secondary500,
  },
  expiredIcon: {
    color: colors.destructive500,
  },
  expiringSoonIcon: {
    color: colors.orange500,
  },
  successIcon: {
    color: colors.success500,
  },
  disabledIcon: {
    color: colors.neutral400,
  },
  multipleIcon: {
    color: colors.purple700,
  },
  inactiveIcon: {
    color: colors.destructive600,
    '& svg': {
      minWidth: '20px',
      minHeight: '20px',
    },
  },
  alertText: {
    color: colors.neutral700,
    fontFeatureSettings: `salt on`,
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    display: 'block',
    flex: 1,
  },
  header: {
    position: 'absolute',
    top: -48,
    left: -64,
    height: 88,
    width: '100vw',
    borderBottom: `1px solid ${colors.neutral100}`,
    paddingLeft: 32,
    paddingRight: 32,
    display: 'flex',
    alignItems: 'center',
  },
  head: {
    display: 'flex',
    gap: 12,
    height: 88,
    alignItems: 'center',
    // padding: '0 24px',
    borderBottom: `1px solid ${colors.neutral100}`,
  },
  name: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 600,
    margin: 0,
  },
  badge: {
    fontSize: 12,
    lineHeight: '16px',
    height: 20,
    textTransform: 'capitalize',
  },
  heading: {
    fontFamily: 'Source Serif Pro',
    margin: 0,
  },
});
